import { useProduct } from 'FeatureModules/ProductPage/hooks/useProduct';
import { contentBlockSchema } from 'FeatureModules/ProductPage/schemas/product.schemas';
import find from 'lodash/find';
import { useMemo } from 'react';
import * as Yup from 'yup';
import { FRONTEND_TO_BACKEND_BLOCK_TYPE_MAP } from '../utils/productBlock.utils';

const useContentBlock = contentBlockType => {
  const {
    loading,
    error,
    latestProductVersion: { contentBlocks },
  } = useProduct();

  const schema = contentBlockSchema[FRONTEND_TO_BACKEND_BLOCK_TYPE_MAP[contentBlockType]]?.schema;

  // wrap data schema so enabled boolean can be sent separately to backend
  const enhancedScheme = useMemo(
    () =>
      Yup.object()
        .shape({
          enabled: Yup.bool().default(true),
        })
        .concat(schema),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const contentBlock = find(contentBlocks, [
    'contentType',
    FRONTEND_TO_BACKEND_BLOCK_TYPE_MAP[contentBlockType],
  ]);

  return [
    {
      ...contentBlock,
      enabled: !!contentBlock.enabled,
    },
    enhancedScheme,
    { loading, error },
  ];
};

export default useContentBlock;
